export const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M16.5 4.5H22.5V22.5H1.5V4.5H7.5" />
        <path d="M12 1.5V15M12 15L7.5 10.5M12 15L16.5 10.5" />
      </g>
    </svg>
  );
};
